import { Avatar, CardMedia, Stack, Tooltip, useMediaQuery, useTheme } from '@mui/material'
import { useInView } from 'react-intersection-observer'
import React from 'react'
import useTenant from '@/hooks/useTenant'
import { getImageUrl } from '@/components/page-specific/gm/components/image'

export type ItemCardMediaProps = {
  imageUrl?: string | null
  imageTitle?: string | null
  vendorName?: string | null
  vendorAvatar?: string | null
}

const ItemCardMedia: React.FC<ItemCardMediaProps> = ({
  imageTitle,
  imageUrl,
  vendorName,
  vendorAvatar,
}) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
  })
  const theme = useTheme()
  const tenant = useTenant()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const width = !isMobile ? 300 : 500
  const url = getImageUrl({
    src: imageUrl || tenant?.marketing.assets?.placeholder || '',
    width,
    quality: 100,
  })
  const avatarUrl = getImageUrl({
    src: vendorAvatar || '',
    width: 100,
    quality: 100,
  })

  const title = imageTitle || ''
  return (
    <CardMedia
      sx={{ height: '100%', minHeight: 160 }}
      image={inView ? url : ''}
      title={title}
      ref={ref}
    >
      {vendorAvatar && vendorName ? (
        <Stack padding={1} height="100%" direction="column-reverse">
          <Tooltip title={vendorName}>
            <Avatar sx={{ width: 44, height: 44 }} alt={vendorName} src={inView ? avatarUrl : ''}>
              &nbsp;
            </Avatar>
          </Tooltip>
        </Stack>
      ) : null}
    </CardMedia>
  )
}

export default ItemCardMedia
